import React, { useState } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import copyToClipboard from './lib/copyToClipboard'
import { FptiClick } from './lib/fpti'
import {
  ICON_CHECK_CIRCLE,
  SHOPPING_MERCHANT_CODE_COPY_PRESSED
} from './lib/client-constants'
import TextLinkAsButton from './TextLinkAsButton'

interface Props {
  couponCode?: string | null
  fptiEvent: FptiClick
}

const CopiedCouponContent = () => {
  return (
    <>
      <img
        className="offer-details-modal-displaycoupon__icon"
        src={ICON_CHECK_CIRCLE}
      />
      <div className="offer-details-modal-displaycoupon__copied ppvx_text--body-strong">
        <Message id="main.shoppingHub.modal.offerDetails.copied" />
      </div>
    </>
  )
}

const OfferDetailsModalDisplayCoupon = ({ couponCode, fptiEvent }: Props) => {
  const [copiedCoupon, setCopiedCoupon] = useState(false)
  const copyText = (val: string) => {
    copyToClipboard(val, 'offerModal')
    setCopiedCoupon(true)
    fptiEvent(SHOPPING_MERCHANT_CODE_COPY_PRESSED, { link_name: 'action' })
  }
  if (couponCode) {
    return (
      <div className="offer-details-modal-displaycoupon">
        <div className="offer-details-modal-displaycoupon__code ppvx_text--heading-md">
          {couponCode}
        </div>
        {copiedCoupon ? (
          <CopiedCouponContent />
        ) : (
          <TextLinkAsButton
            className="offer-details-modal-displaycoupon__copy ppvx_text--body-strong"
            onClick={() => copyText(couponCode)}
          >
            <Message id="main.shoppingHub.modal.offerDetails.copy" />
          </TextLinkAsButton>
        )}
      </div>
    )
  }
  return null
}

export default OfferDetailsModalDisplayCoupon
